__turbopack_context__.v({
  "BackButton": "_0I-38a_BackButton",
  "BackButtonContainer": "_0I-38a_BackButtonContainer",
  "BackButtonLink": "_0I-38a_BackButtonLink",
  "BottomSection": "_0I-38a_BottomSection",
  "Checkout": "_0I-38a_Checkout",
  "Confirmation": "_0I-38a_Confirmation",
  "SwoopTop": "_0I-38a_SwoopTop",
});
